import { Attachment } from './api';

export const ATTACHMENT_EVENT_NAMES = {
  added: '.attachment.added',
  deleted: '.attachment.deleted',
} as const;

export interface AttachmentAddedEvent {
  attachment: Attachment;
  card_id: number;
  board_id: number;
}

export interface AttachmentDeletedEvent {
  attachment_id: number;
  card_id: number;
  board_id: number;
}

export const applyAttachmentAdded = (
  attachments: Attachment[],
  cardId: number,
  event: AttachmentAddedEvent
): Attachment[] => {
  if (event.card_id !== cardId) return attachments;
  if (attachments.some((a) => a.id === event.attachment.id)) return attachments;
  return [event.attachment, ...attachments];
};

export const applyAttachmentDeleted = (
  attachments: Attachment[],
  cardId: number,
  event: AttachmentDeletedEvent
): Attachment[] => {
  if (event.card_id !== cardId) return attachments;
  return attachments.filter((a) => a.id !== event.attachment_id);
};
